var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconB-search",
    x: 0.001,
    y: 0.001,
    width: 23.998,
    height: 23.998,
    style: {
      fill: "none"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconB-search1",
    serifid: "iconB-search"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.321,14.907l5.387,5.387c0.39,0.39 0.39,1.024 -0,1.414c-0.39,0.39 -1.024,0.39 -1.414,-0l-5.387,-5.387c-1.355,1.053 -3.057,1.68 -4.906,1.68c-4.418,-0 -8,-3.582 -8,-8c-0,-4.418 3.582,-8 8,-8c4.418,-0 8,3.582 8,8c-0,1.849 -0.627,3.551 -1.68,4.906Zm-0.32,-4.906c-0,-3.314 -2.686,-6 -6,-6c-3.314,-0 -6,2.686 -6,6c-0,3.314 2.686,6 6,6c3.314,-0 6,-2.686 6,-6Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBSearch);
export default __webpack_public_path__ + "static/media/iconB-search.2eb3d3c83fd1626d6a07188e0a48b8f3.svg";
export { ForwardRef as ReactComponent };